let provider;

export function setDataProvider(dataProvider) {
  if (provider) throw new Error('The data provider has already been set.');
  provider = dataProvider;
}

export function getDataProvider() {
  return provider;
}